<template>
    <div class="simple-form">
        <el-form :model="devcDef" ref="ruleForm" class="demo-ruleForm">
            <div class="form-group" v-if="realDevcDef != null && realDevcDef">
                <div class="form-label">
                    <label class="required">关联资产定义</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="assetDefInnerCode" :rules="{validator: validateItem, trigger: 'change'}">
                        <el-input class="width-1-5x bottom-line" disabled type="text" v-model="devcDef.assetDefInnerCode"></el-input>
                        <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectDevcDefDlg()"></div>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">名称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="name" :rules="{validator: validateItem, trigger: 'blur'}">
                        <el-input class="width-1-5x" :disabled="defId != null || buildFlag" type="text" v-model="devcDef.name" @change="titleChange"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">型号</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="model" :rules="{validator: validateItem, trigger: 'blur'}">
                        <el-input class="width-1-5x" :disabled="defId != null || buildFlag" type="text" v-model="devcDef.model" @change="titleChange"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">规格</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="fixedSpec" :rules="{validator: validateItem, trigger: 'blur'}">
                        <el-input class="width-1-5x" :disabled="defId != null || buildFlag" type="text" v-model="devcDef.fixedSpec" @change="titleChange"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">组装件描述全称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="title" :rules="{validator: validateItem, trigger: 'blur'}">
                        <el-input class="width-1-5x" type="text" v-model="devcDef.title"></el-input>
                    </el-form-item>
                </div>
            </div>

            <div class="form-group">
                <div class="form-label">
                    <label>维保分组</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="devcGroupId">
                        <el-select v-model="devcDef.devcGroupId" placeholder="请选择" filterable @change="changeDevcGroup">
                            <el-option v-for="item in devcGroupList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>

            <div class="form-group">
                <div class="form-label">
                    <label>分类</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="catName">
                        <el-input class="width-1-5x bottom-line" disabled type="text" v-model="devcDef.catName"></el-input>
                        <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectCatDlg()"></div>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>品牌</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="brandName">
                        <el-input class="width-1-5x bottom-line" disabled type="text" v-model="devcDef.brandName"></el-input>
                        <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectBrandDlg()"></div>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">定义编码</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="innerCode" :rules="{validator: validateItem, trigger: 'blur'}">
                        <el-input class="width-1-5x" type="text" v-model="devcDef.innerCode"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">单位</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="theUnit" :rules="{validator: validateItem, trigger: 'blur'}">
                        <el-input class="width-1-5x" :disabled="defId != null" type="text" v-model="devcDef.theUnit"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group top">
                <div class="form-label">
                    <label>图片</label>
                </div>
                <div class="form-value">
                    <swb-file-upload :fileFor="'image-misc'" fileGroup="image-misc" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="false"></swb-file-upload>
                    <div v-if="imgFile != null" class="file-area clearfix">
                        <span v-if="imgFile.fileBrowseUrl != null && imgFile.fileBrowseUrl != ''">
                            <swb-file-item :fileUuid="imgFile.fileUuid" :fileBrowseUrl="imgFile.fileBrowseUrl" :deletable="true" :onDelete="removeUpload"></swb-file-item>
                        </span>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openBrandListSelectDlg } from '../categ/selectDlg'
    import { showDevcGroupCatSelectDlg } from '../categ/selectDlg'
    import { showMerchtDevcDefSelectDlg } from '../devcDef/showDlg'

    import asmblAccApi from '../../api/asmblAcc'
    import goodsCategApi from '../../api/goodsCateg'

    export default{
        name: 'swb-asmbl-acc-def-save',
        desc: '组装件定义保存',
        props: ["defId", "row", "buildFlag", "realDevcDef"],
        data: function () {
            return {
                devcDef: {},
                devcGroupList: [],
                selectCat: {},
                selectBrand: {},
                //
                imgFile: null
            }
        },
        created: function () {
            if(!Utils.isNoB(this.row)) {
                let devcDef = this.row;
                let title = devcDef.name;
                if(!Utils.isNoB(devcDef.model)) {
                    title = title + devcDef.model;
                }
                if(!Utils.isNoB(devcDef.fixedSpec)) {
                    title = title + devcDef.fixedSpec;
                }
                devcDef.title = title;
                this.devcDef = Utils.merge({}, devcDef);
            }
            if(!Utils.isNoB(this.defId)) {
                this.getDevcDefDetail();
            }
            this.getDevcGroupList();
        },
        methods: {
            validateItem: function (rule, value, callback) {
                let devcDef = this.devcDef;
                let field = rule.field;
                if(field == 'name') {
                    if(!Utils.isTrue(this.buildFlag)) {
                        if(Utils.isNoB(value)) {
                            callback(new Error('不能为空!'));
                        } else if(value.length > 30) {
                            callback(new Error('不能大于30个字符!'));
                        } else {
                            callback();
                        }
                    } else {
                        callback();
                    }
                } else if(field == 'model') {
                    if(!Utils.isTrue(this.buildFlag)) {
                        if(Utils.isNoB(value)) {
                            callback(new Error('不能为空!'));
                        } else if(value.length > 30) {
                            callback(new Error('不能大于30个字符!'));
                        } else {
                            if(Utils.isNoB(devcDef.fixedSpec)) {
                                callback();
                            } else {
                                let modelSpec = value + '' + devcDef.fixedSpec;
                                if(modelSpec.length > 60) {
                                    callback(new Error('型号+规格不能大于60个字符!'));
                                } else {
                                    callback();
                                }
                            }
                        }
                    } else {
                        callback();
                    }
                } else if(field == 'fixedSpec') {
                    if(!Utils.isTrue(this.buildFlag)) {
                        if(Utils.isNoB(value)) {
                            callback(new Error('不能为空!'));
                        } else if(value.length > 45) {
                            callback(new Error('不能大于45个字符!'));
                        } else {
                            if(Utils.isNoB(devcDef.model)) {
                                callback();
                            } else {
                                let modelSpec = devcDef.model + '' + value;
                                if(modelSpec.length > 60) {
                                    callback(new Error('型号+规格不能大于60个字符!'));
                                } else {
                                    callback();
                                }
                            }
                        }
                    } else {
                        callback();
                    }
                } else if(field == 'title') {
                    if(Utils.isNoB(value)) {
                        callback(new Error('不能为空!'));
                    } else if(value.length > 60) {
                        callback(new Error('不能大于60个字符!'));
                    } else {
                        callback();
                    }
                } else if(field == 'innerCode') {
                    if(Utils.isNoB(value)) {
                        callback(new Error('不能为空'));
                    } else if(value.length > 20) {
                        callback(new Error('不能大于20个字符!'));
                    } else {
                        callback();
                    }
                } else if(field == 'theUnit') {
                    if(Utils.isNoB(value)) {
                        callback(new Error('不能为空!'));
                    } else if(value.length > 5) {
                        callback(new Error('不能大于5个字符!'));
                    } else {
                        callback();
                    }
                } else if(field == 'assetDefInnerCode' && this.realDevcDef != null && this.realDevcDef) {
                    if(Utils.isNoB(value)) {
                        callback(new Error('不能为空!'));
                    } else {
                        callback();
                    }
                }
            },
            //
            changeDevcGroup: function () {
                let devcDef = this.devcDef || {};
                devcDef.catId = null;
                devcDef.catName = null;
                this.devcDef = Utils.merge({}, devcDef);
            },
            // 选择分类
            selectCatDlg: function () {
                let self = this;
                let devcDef = self.devcDef || {};
                if (Utils.isNoB(devcDef.devcGroupId)) {
                    MsgBox.warning("请选择设备维保分组");
                    return;
                }
                let params = {
                    filter: {
                        groupId: devcDef.devcGroupId,
                        level: 2
                    },
                    checkBox: false,
                };
                showDevcGroupCatSelectDlg(params, function (resultData, theDlg) {
                    theDlg.close();
                    self.selectCat = Utils.merge({}, resultData);
                    devcDef.catId = resultData.catId;
                    devcDef.catName = resultData.catName;
                    self.devcDef = Utils.merge({}, devcDef);
                });
            },
            // 选择品牌
            selectBrandDlg: function () {
                let self = this;
                let devcDef = self.devcDef || {};
                if(Utils.isNoB(devcDef.catId)) {
                    MsgBox.warning("请选择分类！");
                    return;
                }
                let selectBrand = self.selectBrand;
                let selectIds = [];
                if(!Utils.isNoB(selectBrand) && selectBrand.brandId > 0) {
                    selectIds.push(selectBrand.brandId);
                }
                let params = {
                    currentCheckValue: 2,    // 分类品牌
                    selectIds: selectIds,
                    catId: devcDef.catId
                };
                openBrandListSelectDlg(false, params, function (brand) {
                    self.selectBrand = Utils.merge({}, brand);
                    devcDef.brandId = brand.id;
                    devcDef.brandName = brand.dispName;
                    self.devcDef = Utils.merge({}, devcDef);
                });
            },
            //
            getDevcDefDetail: function () {
                let self = this;
                let postData = {};
                postData.id = self.defId;
                //
                let msgBoxDlg = MsgBox.loading();
                asmblAccApi.getAsmblAccDef(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let devcDef = result.data;
                        if(devcDef.devcGroupId == -1) {
                            devcDef.devcGroupId = null;
                        }
                        self.devcDef = Utils.merge({}, devcDef);
                        //
                        let imgFile = {
                            fileBrowseUrl: devcDef.imageUrl
                        };
                        self.imgFile = Utils.merge({}, imgFile);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            //
            getDevcGroupList: function () {
                let self = this;
                let theLoad = MsgBox.loading();
                let postData = {
                    level: 2,
                };
                goodsCategApi.getDevcGroupListByFilter(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let devcGroupList = result.data || [];
                        if(devcGroupList.length > 0) {
                            let devcDef = self.devcDef || {};
                            // devcDef.devcGroupId = devcGroupList[0].id;
                            self.devcDef = Utils.merge({}, devcDef);
                        }
                        self.devcGroupList = Utils.merge([], devcGroupList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            titleChange(){
                let devcDef = this.devcDef;
                if(Utils.isNoB(devcDef.title) && !Utils.isNoB(devcDef.name) && !Utils.isNoB(devcDef.model) && !Utils.isNoB(devcDef.fixedSpec)) {
                    devcDef.title = devcDef.name + '' + devcDef.model + '' + devcDef.fixedSpec;
                    this.devcDef = Utils.merge({}, devcDef);
                }
            },
            // 上传图片
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    MsgBox.warning('喂，你还没选择要上传的文件吧');
                    return false;
                } else {
                    let name = fileItems[0].name;
                    if(!Utils.isNoB(name)) {
                        let hz = name.substring(name.lastIndexOf('.'), name.length);
                        if(hz != '.jpg' && hz != '.jpeg' && hz != '.png' && hz != '.webp') {
                            MsgBox.warning('允许的文件扩展名为：.jpg, .jpeg, .png, .webp');
                            return false;
                        }
                    }
                    let size = fileItems[0].size;
                    let sizeKB = size / 1024;
                    if(sizeKB > 1024) {
                        let sizeMB = (sizeKB / 1024).toFixed(2);
                        MsgBox.warning('最大支持1MB,当前' + sizeMB + 'MB');
                        return false;
                    }
                }
            },
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            onUploadDone: function (result) {
                let self = this;
                if(result.type === 'info') {
                    let files = result.data.files || [];
                    if(files.length > 0) {
                        self.imgFile = files[0];
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            },
            removeUpload: function () {
                this.imgFile = null;
            },
            // 返回数据
            getDlgResult: function () {
                let self = this;
                let result = {
                    type: 'info'
                };
                let devcDef = self.devcDef || {};
                this.$refs['ruleForm'].validate(function (valid) {
                    if(valid) {
                        let resultData = {
                            name: devcDef.name,
                            model: devcDef.model,
                            fixedSpec: devcDef.fixedSpec,
                            modelSpec: devcDef.model + devcDef.fixedSpec,
                            title: devcDef.title,
                            devcGroupId: devcDef.devcGroupId || null,
                            catId: devcDef.catId || -1,
                            catName: devcDef.catName || "",
                            brandId: devcDef.brandId || -1,
                            brandName: devcDef.brandName || "",
                            innerCode: devcDef.innerCode,
                            innerDevcCatName: devcDef.innerDevcCatName,
                            theUnit: devcDef.theUnit,
                            centBuyMode: devcDef.centBuyMode,
                            skuId: devcDef.skuId,
                            imageUrl: Utils.isNoB(self.imgFile) ? null : self.imgFile.fileBrowseUrl,
                            assetDefId: devcDef.assetDefId,
                            assetDefInnerCode: devcDef.assetDefInnerCode,
                            assetDefTitle: devcDef.assetDefTitle
                        };
                        if(!Utils.isNoB(self.defId)) {
                            resultData.id = self.defId;
                        }
                        result.data = resultData;
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败';
                    }
                });
                return result;
            },
            selectDevcDefDlg(){
                let self = this;
                let devcDef = this.devcDef || {};
                //
                let filter = {};
                filter.checkBox = false;
                showMerchtDevcDefSelectDlg(filter, function (def, dlg) {
                    dlg.close();
                    devcDef.assetDefId = def.id;
                    devcDef.assetDefInnerCode = def.innerCode;
                    devcDef.assetDefTitle = def.title;
                    self.devcDef = Utils.merge({}, devcDef);
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/asmblAcc/AsmblAccDefSave.vue